import React from 'react'
import { Button, Typography } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import AreaCard from './AreaCard'

const AreaList = ({ areas, selectedAreaId, onSelect, onAdd, onEdit, onDelete }) => {
  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: 8,
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)', padding: 12
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13 }}>Areas</Typography>
        <Button size="small" startIcon={<AddIcon />} onClick={onAdd}
          style={{ textTransform: 'none', fontSize: 11 }}>
          New Area
        </Button>
      </div>
      {areas.length === 0 ? (
        <Typography variant="body2" color="textSecondary" style={{ fontSize: 12, padding: '8px 0' }}>
          No areas yet. Add one to start capturing notes and photos.
        </Typography>
      ) : (
        areas.map(area => (
          <AreaCard
            key={area._id}
            area={area}
            selected={area._id === selectedAreaId}
            photoCount={area.photoCount || 0}
            unresolvedQuestions={area.unresolvedQuestions || 0}
            onSelect={onSelect}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        ))
      )}
    </div>
  )
}

export default AreaList
